import Button from './NotificationButton';

export default { Button };
